<template>
  <component :is="this.$route.meta.layout || 'div'">
        <b-container
           
          fluid="sm" position="position-fixed"
          ></b-container>
           <router-view></router-view>
           
        </component>
</template>

<style> 
</style>
